import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  id: number;
  name: string;
  display_name: string;
  division: number;
  is_active: boolean;
}

export const useUpdateTeam = () => {
  const { authHeader } = useAuth();

  return useMutation(({ id, ...params }: Params) => {
    return axios.put(`${env.verifyServiceUrl}common/team/${id}/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
